/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Model, { attr } from '@ember-data/model';

export default class Feature extends Model {
  @attr('string') declare app_id: string;
  @attr('number') declare limit: number;
  @attr('boolean') declare limited: boolean;
}
